import { render, staticRenderFns } from "./ClearTagScan.vue?vue&type=template&id=544bb732&scoped=true"
import script from "./ClearTagScan.vue?vue&type=script&lang=js"
export * from "./ClearTagScan.vue?vue&type=script&lang=js"
import style0 from "./ClearTagScan.vue?vue&type=style&index=0&id=544bb732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544bb732",
  null
  
)

export default component.exports